import './assets/style/main.css'
import {ConfiguratorContainer} from "./containers";
import ReactTooltip from "react-tooltip";
import Modal from 'react-modal';


Modal.setAppElement('#root');

export default function App() {
  return (
    <>
      <ConfiguratorContainer/>



      <ReactTooltip />
    </>
  );
}
